<template>
    <div :class="$attrs.class">
        <label v-if="label" class="form-label" :for="id">{{ label }}</label>
        <div class="custom-select-wrapper" ref="dropdownWrapper">
            <div
                class="custom-select-box"
                @click="toggleDropdown"
                :class="{ 'open': isOpen }"
                :aria-expanded="isOpen.toString()"
                tabindex="0"
                ref="input"
            >
                <span v-if="selected.length === 0">{{ __('Select') }}</span>
                <span v-else>{{ getInitials(selected) }}</span>
            </div>
            <div v-if="isOpen" class="custom-select-dropdown">
                <label v-for="(label, value) in options" :key="label.id" class="checkbox-container">
                    <input
                        type="checkbox"
                        :value="label"
                    v-model="selected"
                    />
                    {{ label.name ?? label.title }}
                </label>
            </div>
        </div>
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `select-input-${uuid()}`
            },
        },
        error: String,
        label: String,
        required: {
            type: Boolean,
            default() {
                return false;
            }
        },
        modelValue: {
            type: Array,
            default: () => []
        },
        options: {
            type: Array,
            required: true
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            selected: this.modelValue,
            isOpen: false
        }
    },
    watch: {
        modelValue: {
            handler(newValue) {
                this.selected = newValue;  // Keep selected in sync
            },
            immediate: true, // Ensure it applies on mount
            deep: true
        },
        selected(selected) {
            this.$emit('update:modelValue', selected)
        },
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        closeDropdown() {
            this.isOpen = false;
        },
        focus() {
            this.$refs.input.focus()
        },
        select() {
            this.$refs.input.select()
        },
        handleClickOutside(event) {
            const dropdownWrapper = this.$refs.dropdownWrapper;
            if (dropdownWrapper && !dropdownWrapper.contains(event.target)) {
                this.closeDropdown();
                this.$emit('dropdownClosed', this.modelValue);
            }
        },
        getInitials(selected) {
            if (!Array.isArray(selected)) return '';
            return selected.map(item => (item.name|| item.title)).join(', ');
        },
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    },
}
</script>

<style scoped>
.custom-select-wrapper {
    position: relative;
}

.custom-select-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    border: 1px solid #ccc;
    cursor: pointer;
}

.custom-select-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    border: 1px solid #ccc;
    background-color: #fff;
    z-index: 100;
    max-height: 200px;
    overflow-y: auto;
}

.checkbox-container {
    display: flex;
    align-items: center;
    padding: 8px;
    cursor: pointer;
}

.checkbox-container input {
    margin-right: 8px;
}

.custom-select-box.open .custom-select-dropdown {
    display: block;
}

.form-error {
    color: red;
    font-size: 12px;
}
</style>
